/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback } from 'react';
import SelectWithPagination from 'components/shared/dropdown-with-pagination/SelectWithPagination';
import { Spin } from 'antd';

import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import {
  resetProductMixFilters,
  setIsAccountableProductMix,
  setPrductMixExpression,
  setProductMixProduct,
  setProductMixSquad,
  setProductMixTimePeriod,
} from 'store/customer/customerViewSlice';
import {
  PRODUCT_MIX_COLUMNS,
  PRODUCT_MIX_FILTER_NAME,
  SITE_PERF_APP_ID,
  CHECKBOXCLASS,
  TABLE_NAME_PRODUCT_MIX,
  PAGINATION,
  SORT_BY,
  MODULE_NAME,
  NUMBER_ZERO,
  QUERY_KEY,
  COMPONENT_MAPPING,
} from 'constants/constants';
import {
  exportData,
  getProductMixData,
} from 'store/customer/customer-view-actions';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Form, Tooltip } from 'react-bootstrap';
import { getRestrictedColumn, isArray, getCustomerExpr } from 'utils/utils';
import GNESingleSelect from 'components/shared/dropdown/GNESingleSelect';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';
import OverlayIcon from 'components/shared/overlay-icon/OverlayIcon';
import { useQuery } from '@tanstack/react-query';

const ProductMix = () => {
  const [menuIsOpen, setMenuIsOpen] = useState({
    SiteSquad: false,
    Product: false,
  });
  const isAccountableProduct = useSelector(
    (state) => state?.CustomerView?.productMixFilters?.IsAccountableProduct
  );
  const selectedSquad = useSelector(
    (state) => state?.CustomerView?.productMixFilters?.SiteSquad?.selectedValue
  );
  const selectedProducts = useSelector(
    (state) => state?.CustomerView?.productMixFilters?.Product?.selectedValue
  );

  const timeSpanOptions = useSelector(
    (state) => state?.CustomerView?.timespans
  );
  const isExporting = useSelector((state) => state?.CustomerView?.exportSite);

  const dispatch = useDispatch();

  const selectedCustomer = useSelector(
    (state) => state?.CustomerView?.selectedCustomer
  );

  const filteredColumns = PRODUCT_MIX_COLUMNS;

  const productMixFilters = useSelector(
    (state) => state?.CustomerView?.productMixFilters
  );
  const productOptions = useSelector(
    (state) => state?.CustomerView?.productMixFilters?.Product
  );

  const squadOptions = useSelector(
    (state) => state?.CustomerView?.productMixFilters?.Squad
  );
  let productMixExpression = useSelector(
    (state) => state?.CustomerView?.productMixExpression
  );
  const selectedTimePeriod = useSelector(
    (state) => state?.CustomerView?.productMixFilters?.TimePeriod
  );
  const columnRestriction = useSelector(
    (state) => state?.CustomerView?.columnsRestiction
  );

  const activeSectionTab = useSelector(
    (state) => state?.CustomerView?.activeSectionTab
  );

  useEffect(() => {
    if (!Array.isArray(selectedCustomer)) buildExpression();
  }, [
    selectedCustomer,
    selectedProducts,
    selectedTimePeriod,
    isAccountableProduct,
    selectedSquad,
  ]);

  const [timeSpan, setTimeSpan] = useState('');

  useEffect(() => {
    setTimeSpan(
      timeSpanOptions
        ?.filter(
          (item) =>
            item.Module === MODULE_NAME.ProductMix &&
            item.TimePeriod === selectedTimePeriod?.selectedValue?.label
        )
        [NUMBER_ZERO]?.Value?.replaceAll("'", ' ')
    );
  }, [timeSpanOptions, selectedTimePeriod]);

  const initailState = {
    values: [],
    offset: 0,
    totalSize: 0,
  };

  const [productMixData, setProductMixData] = useState(initailState);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(PAGINATION.defaultPageSize);
  const [sortBy, setSortBy] = useState({
    column: 'grossSales',
    order: SORT_BY.descend,
  });

  const pagination = {
    current: pageIndex,
    total: productMixData?.totalSize,
    pageSize: pageSize,
    pageSizeOptions: PAGINATION.pageSizeOptions,
    showSizeChanger: true,
    disabledPageSizehandler: true,
  };

  const timePeriodOptions = [
    { value: 'R3', label: 'R3M' },
    { value: 'R6', label: 'R6M' },
    { value: 'R12', label: 'R12M' },
    { value: 'YTD', label: 'YTD' },
  ];

  const buildExpression = () => {
    const isAllProd =
      isArray(productOptions) &&
      productOptions?.length === selectedProducts?.length;

    const isAllSquad =
      isArray(squadOptions) && squadOptions?.length === selectedSquad?.length;

    const squad = isAllSquad ? 'Squad=' : selectedSquad;
    const products = isAllProd ? 'Product=' : selectedProducts;
    const accountExp = getCustomerExpr(
      selectedCustomer,
      isArray(selectedCustomer)
    );

    // build product expression
    const productExp = isArray(products)
      ? 'Product={"' + products.map((a) => a.label).join('","') + '"}'
      : '';

    // build business site expression

    const squadExp = isArray(squad)
      ? 'Squad={"' + squad.map((a) => a.label).join('","') + '"}'
      : '';
    productMixExpression = `${accountExp}`;
    if (productExp !== '')
      productMixExpression = productMixExpression.concat(`, ${productExp}`);
    if (squadExp !== '')
      productMixExpression = productMixExpression.concat(`, ${squadExp}`);
    if (isAccountableProduct !== undefined && isAccountableProduct === true)
      productMixExpression = productMixExpression.concat(
        ', "isAccountableProduct"={"Y"}'
      );
    dispatch(setPrductMixExpression(productMixExpression));
  };

  // React Query to fetch Site Utilization Data
  const { data, isLoading } = useQuery({
    queryKey: [
      QUERY_KEY.ProductMixTable,
      selectedCustomer?.value,
      selectedProducts,
      selectedSquad,
      selectedTimePeriod?.selectedValue,
      isAccountableProduct,
      sortBy.column,
      sortBy.order,
      pageIndex,
      pageSize,
    ],
    queryFn: async () => {
      const result = await getProductMixData(
        productMixExpression,
        0, // will set actual offset and pageSize once pagination done from backend,
        selectedTimePeriod?.selectedValue,
        sortBy.column,
        sortBy.order
      );

      return result?.values?.length > 0 ? result : initailState;
    },
    enabled: activeSectionTab === COMPONENT_MAPPING.ProductMix ? true : false,
  });

  // Update local state when query data changes
  useEffect(() => {
    if (data) {
      setProductMixData(data);
    }
  }, [data]);

  const handleTableChange = (column, order, pagination) => {
    let currentPageSize = pagination.pageSize;

    // Reset page to 1 if page size changed
    if (pageSize !== currentPageSize) {
      setPageIndex(1);
      setPageSize(currentPageSize);
    } else {
      setPageIndex(pagination.current);
    }

    setSortBy({ column, order: SORT_BY[order] });
  };

  const handleAccountProdCheckbox = (e) => {
    dispatch(setIsAccountableProductMix(e?.target?.checked));
    dispatch(setProductMixProduct({ options: [], selectedValue: [] }));
    dispatch(setProductMixSquad({ options: [], selectedValue: [] }));
  };

  const onMenuOpen = useCallback((filterName, value) => {
    let menuIsOpenLocal = menuIsOpen;
    if (filterName !== '' && value) {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: filterName === key };
      }, {});
    } else if ((filterName !== '' && !value) || filterName === '') {
      menuIsOpenLocal = Object.keys(menuIsOpen).reduce((acc, key) => {
        return { ...acc, [key]: false };
      }, {});
    }
    setMenuIsOpen({ ...menuIsOpenLocal });
  }, []);

  const downloadData = () => {
    dispatch(
      exportData(
        'ProductMix',
        selectedCustomer?.value,
        productMixExpression,
        selectedTimePeriod?.selectedValue
      )
    );
  };

  const resetFilters = () => {
    dispatch(resetProductMixFilters({ retainTimePeriod: true }));
  };

  const exportTooltip = (
    <Tooltip className='gne-tooltip'>Send to Excel</Tooltip>
  );

  const handleFilterChange = (value) => {
    setPageIndex(1);
  };

  const size = { x: 800, y: 400 };
  return (
    <div id='ProductMix'>
      <Row>
        <Col
          className='pt-3'
          md={6}>
          <p className='title title__bold title__large mb-0'>Product Mix</p>
          <p className='title__small pt-0 text text__grey'>{timeSpan}</p>
        </Col>
        <Col
          className='pt-3 d-flex justify-content-end'
          md={6}>
          <OverlayIcon
            tooltip={'Reset Filters'}
            onClick={resetFilters}
            className={`icon icon__reset-filters  mt-2 mx-3`}
          />
          <OverlayTrigger overlay={exportTooltip}>
            <i
              onClick={downloadData}
              className={`icon icon__affiliations_export_excel1 mt-2`}
            />
          </OverlayTrigger>
        </Col>
      </Row>
      <Row>
        <Col md={2}>
          <label className='title__x-small'>Time Period</label>
          <GNESingleSelect
            value={selectedTimePeriod?.selectedValue}
            onChange={(e) => {
              dispatch(
                setProductMixTimePeriod({
                  selectedValue: e,
                })
              );
              setPageIndex(1);
            }}
            options={timePeriodOptions}
            className='single-select'
          />
        </Col>
        <Col md={2}>
          <label className='title__x-small'>Squad</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            appid={SITE_PERF_APP_ID}
            filter={productMixFilters}
            fieldName='SiteSquad'
            isMulti={true}
            filterName={PRODUCT_MIX_FILTER_NAME}
            cacheUniqs={[
              selectedCustomer,
              isAccountableProduct,
              selectedProducts,
              selectedTimePeriod,
            ]}
            onChange={handleFilterChange}
          />
        </Col>

        <Col md={2}>
          <label className='title__x-small'>Products</label>
          <SelectWithPagination
            menuIsOpen={menuIsOpen}
            onMenuOpen={onMenuOpen}
            appid={SITE_PERF_APP_ID}
            filter={productMixFilters}
            fieldName='Product'
            isMulti={true}
            filterName={PRODUCT_MIX_FILTER_NAME}
            cacheUniqs={[
              selectedCustomer,
              isAccountableProduct,
              selectedSquad,
              selectedTimePeriod,
            ]}
            onChange={handleFilterChange}
          />
        </Col>
        <Col md={4}>
          <label className='title__x-small w-100'></label>
          <span className='title__small'>
            <Form.Check
              inline
              type='checkbox'
              label='Accountable Products'
              checked={isAccountableProduct}
              onChange={handleAccountProdCheckbox}
              className={isAccountableProduct && CHECKBOXCLASS}
            />
          </span>
        </Col>
      </Row>
      &nbsp;
      <Row>
        <Col>
          <Spin spinning={isLoading || isExporting}>
            <ConfigurableTable
              rows={productMixData?.values || []}
              columns={getRestrictedColumn(
                TABLE_NAME_PRODUCT_MIX,
                filteredColumns,
                columnRestriction
              )}
              expandRowByClick={false}
              enableColumnSelection={false}
              enableExport={false}
              exportFileName='productMixDetails'
              tableName={TABLE_NAME_PRODUCT_MIX}
              expression={productMixExpression}
              isGlobalExport={true}
              pagination={pagination}
              isGlobalSort={true}
              onSort={handleTableChange}
              timePeriod={selectedTimePeriod?.selectedValue}
              dimentions={size}
            />
          </Spin>
        </Col>
      </Row>
    </div>
  );
};

export default ProductMix;
